import { createFormAction } from 'redux-form-saga';
import * as categoryTRFormTypes from './categoryTRFormTypes';
import {createAction} from "redux-actions";

export const submitCategoryForm = createFormAction(categoryTRFormTypes.SUBMIT_CATEGORY_TR_FORM);
export const loadForm = createAction(categoryTRFormTypes.LOAD_FORM);
